import React, { useEffect, useState } from 'react';
import ChartRanking from '../ChartRanking';
import { ResponsiveContainer } from 'recharts';
import MediaChart from '../MediaChart';
import UserChart from '../UserChart';

import ranking1 from './images/escudo_ranking1.png';
import ranking2 from './images/escudo_ranking2.png';
import ranking3 from './images/escudo_ranking3.png';

import Shield from './Shield';

export default function Ranking(props) {

    const {
        chartData = [],
        first,
        second,
        third,
    } = props?.data || {}

    return (

        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'start',
                alignItems: 'center',
                width: '100%',
                // height: '100%',
                height: 'fit-content',
                zIndex: 5,
                overflowY: 'auto',
            }}
        >
            {chartData?.length > 0 &&
                <div className='flex flex-col mt-[20px] w-full' style={{ height: '50%', width: '100%' }}>
                    {/* container podium */}
                    {props.containerTitle && props.containerTitle}
                    <div className='flex flex-row justify-evenly flex-wrap w-full 3xl:justify-between 3xl:pl-[15%]'>
                        <Shield shieldurl={ranking2} avatarurl={second?.avatar} text={second?.name} containerwidth='w-[150px] 3xl:w-[250px]'/>
                        <Shield shieldurl={ranking1} avatarurl={first?.avatar} text={first?.name} containerwidth='w-[220px] 3xl:w-[350px]'/>
                        <Shield shieldurl={ranking3} avatarurl={third?.avatar} text={third?.name} containerwidth='w-[150px] 3xl:w-[250px]'/>

                    </div>
                </div>
            }
        </div>
    );
}